import { render } from "./AboutPage.vue?vue&type=template&id=4b3aea1c"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=4b3aea1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__